import { renderToMjml } from "@faire/mjml-react/utils/renderToMjml";
import { EmailFormat } from "@redotech/redo-model/email-builder";
import { mjmlHtmlToAmpHtml } from "../mjml-to-amp";
import { NativeQueryEngine } from "./native-dom-query-engine-adapter";

// Think of this next line as `import * as mjml2html from "mjml";`
// There's some cursed ES module / CommonJS problem.
// The normal import syntax actually works but doesn't get past type checking.
// eslint-disable-next-line
const mjml2html: typeof import("mjml-browser") = require("mjml-browser");

/**
 * Functionally identical to the backend render pipeline
 * except that it uses JQuery instead of Cheerio, and mjml-browser instead of mjml.
 * (and it doesn't log errors)
 * Both are drop-in replacements.
 */
export function renderEmailPreview(
  reactElement: JSX.Element,
  format: EmailFormat,
): string {
  const mjml = renderToMjml(reactElement);
  const mjmlResults = mjml2html(mjml);
  if (mjmlResults.errors.length > 0) {
    console.error("Error parsing MJML", mjmlResults.errors, "MJML:", mjml);
  }
  const mjmlHtml = mjmlResults.html;

  // the backend renderer seems to insert the doctype automatically,
  // but not the frontend, weirdly

  if (format === EmailFormat.STATIC) {
    return withDoctype(mjmlHtml);
  }

  const doc = new DOMParser().parseFromString(mjmlHtml, "text/html");
  const queryEngine = new NativeQueryEngine(doc);

  const ampCompliantHtml = mjmlHtmlToAmpHtml(queryEngine);
  return withDoctype(ampCompliantHtml);
}

/**
 * Adds a doctype to the HTML string if it doesn't already have one.
 * The backend renderer seems to do this automatically, but the frontend doesn't.
 */
function withDoctype(html: string): string {
  return html.startsWith("<!DOCTYPE html>") ? html : `<!DOCTYPE html>${html}`;
}
